/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateEmailStore } from '../../axios/candidateEmailStore'
import type {
	CandidateEmailStoreError,
	CandidateEmailStorePathParams,
	CandidateEmailStoreRequest,
	CandidateEmailStoreResponse,
} from '../../types/CandidateEmailStore'

export const candidateEmailStoreMutationKey = () => [{ url: '/candidates/:candidateId/emails' }] as const

export type CandidateEmailStoreMutationKey = ReturnType<typeof candidateEmailStoreMutationKey>

export type CandidateEmailStoreVariables = {
	candidateId: CandidateEmailStorePathParams['candidateId']
	data: CandidateEmailStoreRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::store */
export function useCandidateEmailStore<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateEmailStoreResponse,
		AxiosError<CandidateEmailStoreError>,
		CandidateEmailStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateEmailStoreMutationKey(),
		mutationFn: ({ candidateId, data }: CandidateEmailStoreVariables) =>
			candidateEmailStore(candidateId, data, config).then(res => res.data),
		...options,
	})
}
